import { FooterMUTAMIByStepName } from "@src/Footer/MUTAMI/FooterMUTAMIByStepName";
import { StepName } from "@src/Steps/Steps";
import { MouseEvent } from "react";

type FooterLegalMutamiProps = {
  stepName: StepName;
};

export function ProtectionDonneesMutami() {
  const openMailTo = (e: MouseEvent) => {
    window.open("mailto:dpo@mutami.fr", "mail");
    e.preventDefault();
  };

  return (
    <p>
      <small>
        Le contrat sâge autonomie vous est proposé par la Mutuelle Mutami,
        Mutuelle régie par les dispositions du Livre II du Code de la mutualité,
        immatriculée au répertoire Sirene sous le n°776 950 677 dont le siège
        social est situé au 70, boulevard Matabiau - CS 46951 - 31069 TOULOUSE
        CEDEX 7. Mutuelle soumise à l&apos;Autorité de contrôle prudentiel et de
        résolution (ACPR : 4 place de Budapest - CS 92459 - 75436 PARIS CEDEX
        09). Elle agit en en qualité de distributeur de Tutélaire, créateur et
        assureur du contrat sâge autonomie.
        <br />
        <br />
        <span style={{ textDecoration: "underline" }}>
          Données personnelles :
        </span>{" "}
        les informations recueillies dans le présent formulaire, ont pour
        finalité de pouvoir vous rappeler et répondre à vos questions.
        <br />
        Vous disposez des droits d’accès, de rectification, d’opposition, de
        portabilité, d'effacement et de limitation du traitement vous
        concernant.
        Pour les exercer, adressez un courrier simple au responsable de traitement soit par e-mail à l’adresse électronique suivante : {" "}
        <a
          href="mailto:dpo@mutami.fr"
          target="_blank"
          rel="noreferrer"
          onClick={openMailTo}
        >
          dpo@mutami.fr
        </a>
        , soit par courrier à l’adresse postale suivante : DPO – MUTAMI, 70, boulevard Matabiau – CS46951, 31069 Toulouse Cedex 7.
        <br />
        Pour plus d&apos;informations relatives à la gestion de vos données,
        vous pouvez à tout moment consulter notre politique de confidentialité sur le site internet{' '}
        <a href="https://www.mutuelle-mutami.fr/" target="_blank" rel="noreferrer">
          www.mutuelle-mutami.fr
        </a>{" "}
        ou la demander par courrier simple au responsable de traitement de MUTAMI,
        mutuelle soumise aux dispositions du livre II du Code de la II du Code de la Mutualité,
        dont le siège social est situé 70 Boulevard Matabiau - CS 46951 - 31069 Toulouse Cedex 7 et immatriculée sous le numéro Siren 776 950 677.
      </small>
    </p>
  );
}

export function FooterLegalMutami({ stepName }: FooterLegalMutamiProps) {
  return (
    <>
      <div className="footer-legal__part">
        <FooterMUTAMIByStepName stepName={stepName} />
      </div>
      <div className="footer-legal__part">
        <div className="footer-legal__logos">
          <img
            className="footer-legal__logo-tutelaire"
            alt="logo tutelaire"
            src="/logo-tutelaire.png"
          />
          <img
            className="footer-legal__logo-mutualite"
            alt="logo mutualité francaise"
            src="/logo-mutualite-francaise.png"
          />
        </div>
        <div className="stepper__mentions-legales">
          <a
            href="https://www.tutelaire.fr/mentions-legales-cookies"
            target="_blank"
            rel="noreferrer"
          >
            Mentions légales Tutélaire
          </a>
        </div>
        <div className="stepper__mentions-legales">
          <a
            href="https://www.mutuelle-mutami.fr/mentions-legales/"
            target="_blank"
            rel="noreferrer"
          >
            Mentions légales Mutami
          </a>
        </div>
      </div>
    </>
  );
}
